import {
  Login,
  ChangePassword,
  ForgotPassword,
  ResetPasswordWithOtp,
} from "@/pages";
import { useRoutes } from "react-router-dom";
import { routes } from "./utils";
import { NotFound } from "@/components";
import { AdminRoutes } from "./AdminRoutes";
import { CamRoutes } from "./CamRoutes";
import { OwnerBomRoutes } from "./OwnerBomRoutes";

export type Role =
  | "ROLE_ADMIN"
  | "ROLE_OWNER"
  | "ROLE_BOM"
  | "ROLE_CAM"
  | "ROLE_CAM_ACCOUNTANT";

export const routerRoles = {
  admin: "ROLE_ADMIN",
  owner: "ROLE_OWNER",
  bom: "ROLE_BOM",
  cam: "ROLE_CAM",
  cam_a: "ROLE_CAM_ACCOUNTANT",
};

export const Router = () => {
  const element = useRoutes([
    {
      path: routes.root,
      element: <Login />,
    },
    {
      path: routes.login,
      element: <Login />,
    },
    {
      path: routes.changePassword,
      element: <ChangePassword />,
    },
    {
      path: routes.forgotPassword,
      element: <ForgotPassword />,
    },
    {
      path: routes.resetPasswordOtp,
      element: <ResetPasswordWithOtp />,
    },
    AdminRoutes(),
    ...OwnerBomRoutes(),
    CamRoutes(),
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return element;
};
